module.exports = __webpack_public_path__ + "img/spirit_natural_ba_list.2767b741.jpg";